import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import UnifiedPricing from "../components/UnifiedPricing";
import FreeMediaCheck from "../components/FreeMediaCheck";
import TrustSection from "../components/TrustSection";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen bg-background w-full overflow-x-hidden">
      <SEO
        title="OnlineSicher24 | Betrugsschutz für Senioren – Hamm"
        description="Professioneller Betrugsschutz für Senioren: KI-Analyse, persönliche Hotline, Smartphone-Hilfe und kostenloser Phishing-Check. Jetzt sicher online unterwegs."
        canonicalPath="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "OnlineSicher24 - Betrugsschutz für Senioren",
          url: "https://onlinesicher24.de/",
          description:
            "Professioneller Betrugsschutz für Senioren mit KI-Analyse, persönlicher Hotline und Smartphone-Hilfe.",
          inLanguage: "de-DE",
          isPartOf: { "@id": "https://onlinesicher24.de/#website" },
          about: { "@id": "https://onlinesicher24.de/#organization" },
        }}
      />
      <Header />
      <main className="w-full">
        <Hero />
        <div id="services">
          <Services />
        </div>
        <div id="preise">
          <UnifiedPricing />
        </div>
        <div id="free-check">
          <FreeMediaCheck />
        </div>
        <TrustSection />
      </main>
      <div id="kontakt">
        <Footer />
      </div>
    </div>
  );
};

export default Index;
